// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__FwRRL","item":"PaymentsMobile_item__37MPq","label":"PaymentsMobile_label__XTDYl","amount":"PaymentsMobile_amount__as218"};